/**
 * Web component to play and stop videos that are in viewport.
 *  Example usage:
 *  <video-observer class="block">
      {{ section.settings.video | video_tag: preload: "none", muted: true, autoplay: false, loop: true, playsinline: true, controls: false, image_size: '1440x', class: video_class }}
    </video-observer>
 */

class MainProduct extends HTMLElement {
  /** @type {HTMLelementElement | null} */
  holder = null;

  /** @type {IntersectionObserver | null} */
  observer = null;

  /** @type {{ threshold: number }} */
  options = {
    threshold: 0,
  };

  connectedCallback() {
    const holder = this.querySelector('[data-observer-target="holder"]');
    this.options = {
      ...this.options,
      ...JSON.parse(this.dataset.options || '{}'),
    };

    if (holder) {
      this.holder = holder;
      if (this.holder && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.observerCallback, {
          threshold: this.options.threshold,
        });
        this.observer.observe(this.holder);
      } else if (this.holder) {
        // this.holder.play();
      }
    }

    this.mql = window.matchMedia('(min-width: 1024px)');

    // Check the media query list again when the screen size changes, remove the class when its matching.
    this.mql.addEventListener('change', () => {
      if (this.mql.matches) this.holder.classList.remove('out-view');
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  observerCallback = (entries) => {
    entries.forEach((entry) => {
      const { target: holder } = entry;
      !entry.isIntersecting && !this.mql.matches
        ? this.holder.classList.add('out-view')
        : this.holder.classList.remove('out-view');
    });
  };
}

customElements.define('main-product', MainProduct);
